import { Link } from "react-router-dom";

import { ROUTES } from "../../../common/navigation";
import { getIQLevel } from "../../../utils/footballIQ";
import styles from "./IQPill.module.css";

/**
 * Header identity chip: alias + Football IQ (PRD §11).
 * Doubles as the shortcut into the profile screen.
 */
const IQPill = ({ alias, iq = 0, compact = false }) => {
  if (!alias) return null;

  const level = getIQLevel(iq);

  return (
    <Link
      to={ROUTES.PROFILE}
      className={`${styles.IQPill} ${compact ? styles.compact : ""}`.trim()}
      title={`${alias} · Football IQ ${iq} · ${level.label}`}
    >
      <span className={styles.alias}>{alias}</span>
      <span className={`${styles.iq} app-numeric`}>
        <i className="fa-solid fa-brain" aria-hidden="true" />
        <span>{iq}</span>
        <span className="visually-hidden">Football IQ, {level.label}</span>
      </span>
    </Link>
  );
};

export default IQPill;
